import {Route, Routes} from 'react-router';

import BaseContainer from './components/BaseContainer';
import NotFoundPage from './pages/NotFoundPage';
import IndexPage from './pages/IndexPage';
import PublicViewerPage from './pages/PublicViewerPage';
import PrivateViewerPage from './pages/PrivateViewerPage';

const AppRouter = () => {
  return (
    <Routes>
      <Route element={<BaseContainer />}>
        <Route path={'/'} element={<IndexPage />} />
        <Route path={'/public'} element={<PublicViewerPage />} />
        <Route path={'/private'} element={<PrivateViewerPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
};

export default AppRouter;
